(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parts-store-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-parts-catalog]').forEach((catalog) => {
    const search = catalog.querySelector('[data-parts-search]');
    const category = catalog.querySelector('[data-parts-category]');
    const cards = [...catalog.querySelectorAll('[data-parts-card]')];
    const grid = catalog.querySelector('[data-parts-grid]');
    const results = catalog.querySelector('[data-parts-results]');
    const reset = catalog.querySelector('[data-parts-reset]');
    const empty = catalog.querySelector('[data-parts-empty]');
    const layoutButtons = [...catalog.querySelectorAll('[data-parts-layout]')];

    if (!search || !category || !grid) return;

    const update = () => {
      const term = search.value.trim().toLowerCase();
      const selectedCategory = category.value;
      let visible = 0;

      cards.forEach((card) => {
        const matchesTerm = !term || card.dataset.search.includes(term);
        const matchesCategory = !selectedCategory || card.dataset.category === selectedCategory;
        card.hidden = !(matchesTerm && matchesCategory);
        if (!card.hidden) visible += 1;
      });

      const resultLabel = visible === 1 ? catalog.dataset.resultSingular : catalog.dataset.resultPlural;
      results.textContent = `${visible} ${resultLabel}`;
      reset.hidden = !term && !selectedCategory;
      empty.hidden = visible !== 0;
      grid.hidden = visible === 0;
    };

    const transitionUpdate = () => {
      if (document.startViewTransition) document.startViewTransition(update);
      else update();
    };

    search.addEventListener('input', transitionUpdate);
    category.addEventListener('change', transitionUpdate);
    reset.addEventListener('click', () => {
      search.value = '';
      category.value = '';
      transitionUpdate();
      search.focus();
    });

    layoutButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const changeLayout = () => {
          grid.dataset.layout = button.dataset.partsLayout;
          layoutButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        };
        if (document.startViewTransition) document.startViewTransition(changeLayout);
        else changeLayout();
      });
    });

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
